





















import Vue from 'vue'

export default Vue.extend({
  name: 'CheckedInput',
  props: {
    label: {
      type: String,
      default: ''
    },
    cellData: {
      type: String,
      default: ''
    },
    length: {
      type: Number,
      default: 0
    },
    keyName: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    cells: [] as string[]
  }),
  watch: {
    cellData(str: string) {
      if (str) {
        str.split('').forEach((item, index) => {
          this.$refs[`cell${index + 1}`][0].value = item
        })
      }
    },
    cells(val: string[]) {
      if (val) {
        this.$emit('get-checked-input-value', this.keyName, this.cells.join(''))
      }
    }
  },
  methods: {
    validateInput(event) {
      const input = event.target.value
      const index = event.target.selectionStart
      const val = input.slice(0, index) + event.key + input.slice(index)
      if (!/^([0-9]{1,11})$/.test(val)) return event.preventDefault()
    }
  }
})
